import { render } from "./SidebarBuilder.vue?vue&type=template&id=08b14e98"
import script from "./SidebarBuilder.vue?vue&type=script&lang=js"
export * from "./SidebarBuilder.vue?vue&type=script&lang=js"

import "./SidebarBuilder.vue?vue&type=style&index=0&id=08b14e98&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__